import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import SmsIcon from '../../../assets/img/otp_methods/sms.svg';
import WhatsAppIcon from '../../../assets/img/otp_methods/whatsapp.svg';
import { SelectPill } from '../../../components/SelectPill';
import Button from '../../../react-components/Button';
import { Text } from '../../../react-components/Text';
import { OTP_METHODS } from '../../../repositories/session';
import { useAuth } from '../hooks/useAuth';

export const OTPFormSelect = () => {
  const { otpMethod, setOTPMethod, setAuthScreen } = useAuth();

  return (
    <Grid container direction="column" alignItems="center" style={{ width: `100%` }} gap="12px">
      <Text
        intlId="drivers.auth.otp.select_method.title"
        variant="h5"
        style={{ textAlign: `center`, color: RoutalPalette.primary60 }}
      />
      <Grid container direction="column" gap="24px">
        <Text
          intlId="drivers.auth.otp.select_method.info"
          variant="body"
          style={{ textAlign: `center`, color: RoutalPalette.secondary00 }}
        />

        <Grid container direction="column" gap="8px">
          {OTP_METHODS.map((method) => {
            const label = method === `sms` ? `SMS` : `WhatsApp`;
            return (
              <SelectPill
                radialIconPosition="right"
                key={method}
                onClick={() => {
                  setOTPMethod(method);
                }}
                selected={method === otpMethod}
              >
                <Grid container direction="row" gap="8px" alignItems="center">
                  <img src={method === `sms` ? SmsIcon : WhatsAppIcon} alt="" />
                  <Text>{label}</Text>
                </Grid>
              </SelectPill>
            );
          })}
        </Grid>

        <Button
          intlId="drivers.auth.select_method.continue"
          onClick={() => {
            setAuthScreen(`login-phone`);
          }}
        />
      </Grid>
    </Grid>
  );
};
